module.exports = __webpack_public_path__ + "img/laboratorio4_4-3_1536.0c891d79.jpg";